// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { getInputStylesCss } from '../internal/utils/input-styles';
export function getInputStyles(style) {
    return getInputStylesCss(style);
}
//# sourceMappingURL=styles.js.map